let language = {
    THIRD_PARTY_HAVE_ACCOUNT_TEXT: "If you have a Google account, you can also use those accounts to log into {{appName}}",
    
    THIRD_PARTY_SOCIAL_TYPE_GOOGLE: "Google",
    THIRD_PARTY_OR_TEXT: "or",
};

export { language }